<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<re-alert *ngIf="showMessage" type="success" (close)="showMessage = false">
  <strong>Password changed successfully.</strong>
</re-alert>
<ng-template #popContent>
  <re-password-requirements [password]="this.changePasswordForm.value.newPassword"
                            [username]="this.claimsService.getPreferredName().toLowerCase()"
                            [firstName]="this.claimsService.getFirstName()"
                            [lastName]=" this.claimsService.getLastName()">
                           
  </re-password-requirements>

</ng-template>

<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
  <div class="card bg-light">
    <div class="card-header">
      Password Settings
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4">
            <button class="btn btn-default" type="button" *ngIf="!edit" (click)="clickEdit()">Edit</button>
            <button class="btn btn-success" type="submit" *ngIf="edit" [disabled]="changePasswordForm.invalid || !validatePassword()">Save</button>
            <button class="btn btn-cancel" type="button" *ngIf="edit" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6 col-lg-4" [ngClass]="{'input-required': edit}">
          <label for="oldPassword">Current password</label>
          <input id="oldPassword" formControlName="oldPassword" class="form-control" [type]="edit ? 'password' : 'text'" [ngClass]="{'form-control': edit, 'form-control-plaintext': !edit}" [readonly]="!edit">
          <small *ngIf="changePasswordForm.controls['oldPassword'].hasError('required') && changePasswordForm.controls['oldPassword'].touched" class="text-danger">Please enter your current password.</small>
        </div>
      </div>
      <div class="row" *ngIf="edit">
        <div class="form-group col-sm-6 col-lg-4 input-required">
          <label for="newPassword">New password</label>
          <input id="newPassword" formControlName="newPassword" class="form-control" type="password" [ngbPopover]="popContent" popoverTitle="Password Requirements" placement="right" triggers="focus:blur outsideClick"
                 (input)="valueChange()">
          <small *ngIf="changePasswordForm.controls['newPassword'].hasError('required') && changePasswordForm.controls['newPassword'].touched" class="text-danger" >Please enter new password.</small>
          <small *ngIf="!validatePassword() && changePasswordForm.controls['newPassword'].touched" class="text-danger">New password does not match with password requirements.</small>
        </div>
      </div>
      <div class="row" *ngIf="edit">
        <div class="form-group col-sm-6 col-lg-4 input-required">
          <label for="confirmPassword">Confirm new password</label>
          <input id="confirmPassword" formControlName="confirmPassword" class="form-control" type="password">
          <small *ngIf="changePasswordForm.controls['confirmPassword'].hasError('required') && changePasswordForm.controls['confirmPassword'].touched" class="text-danger">Please enter confirm password.</small>
          <small *ngIf="changePasswordForm.controls['confirmPassword'].hasError('compare') && changePasswordForm.controls['confirmPassword'].touched" class="text-danger">Confirm password does not match with new password.</small>
        </div>
      </div>
      </div>
  </div>
</form>
